<script setup lang="ts">
const props = defineProps<{
  url: string
}>()

const videoInformation = getVideoInformation(props.url)
</script>

<template>
  <VideoPreviewPlayerVimeo v-if="videoInformation?.isVimeo" :video-information="videoInformation" />
  <VideoPreviewPlayerYoutube v-else-if="videoInformation?.isYoutube" :video-information="videoInformation" />
  <div v-else class="flex aspect-video items-center justify-center border border-neutral-500 bg-neutral-400">
    <div class="text-center">
      <UIcon name="bx:video-off" class="mb-2 size-8 text-neutral-600" />
      <p class="text-neutral-700">
        Video niet beschikbaar
      </p>
    </div>
  </div>
</template>
